import { getCookieConsent } from '../components/CookieBanner';

// Use the CDN-loaded amplitude instance (window.amplitude)
// This ensures analytics and engagement share the same instance
const amp = () => window.amplitude;

const isEnabled = () => getCookieConsent() !== 'declined' && !!amp();

const track = (event, properties = {}) => {
  if (!isEnabled()) return;
  try {
    amp().track(event, properties);
  } catch (e) {
    console.warn('Analytics track:', e.message);
  }
};

const displayRole = (role) => role === 'explorer' ? 'user' : role;

const identify = (userId, traits = {}) => {
  if (!isEnabled()) return;
  try {
    const a = amp();
    a.setUserId(userId);
    if (traits && Object.keys(traits).length > 0) {
      const normalized = { ...traits };
      if (normalized.role) normalized.role = displayRole(normalized.role);
      const identifyObj = new a.Identify();
      Object.entries(normalized).forEach(([key, value]) => {
        identifyObj.set(key, value);
      });
      a.identify(identifyObj);
    }
  } catch (e) {
    console.warn('Analytics identify:', e.message);
  }
};

// Pre-defined events
const analytics = {
  // Auth
  login: (method) => track('user_login', { method }),
  register: (role) => track('user_register', { role: displayRole(role) }),
  logout: () => track('user_logout'),

  // Search
  search: (filters) => track('search', {
    query: filters.search || '',
    location: filters.location || '',
    has_dates: !!(filters.dateFrom),
    category: filters.category || '',
  }),

  // Activity
  viewActivity: (activity) => track('view_activity', {
    activity_id: activity.activity_id,
    title: activity.title,
    category: activity.category,
    city: activity.city,
    price: activity.price,
  }),
  registerActivity: (activityId, price) => track('register_activity', {
    activity_id: activityId,
    price,
  }),
  joinWaitlist: (activityId) => track('join_waitlist', { activity_id: activityId }),

  // Engagement
  toggleFavorite: (activityId, isFavorited) => track('toggle_favorite', {
    activity_id: activityId,
    action: isFavorited ? 'add' : 'remove',
  }),
  shareActivity: (activityId, method) => track('share_activity', {
    activity_id: activityId,
    method,
  }),
  sendMessage: (recipientId) => track('send_message', { recipient_id: recipientId }),

  // Creator
  createActivity: (category) => track('create_activity', { category }),
  editActivity: (activityId) => track('edit_activity', { activity_id: activityId }),

  // Navigation
  pageView: (page) => track('page_view', { page }),

  // Identity
  identify,
};

export default analytics;
